import { isAxiosError } from 'axios';
import { extractApiErrorMessages } from 'utils/extract-api-error-messages';

const FALLBACK = 'Failed to create new structure';

export function formatCreateStructureError(error: unknown): string {
  if (!isAxiosError(error)) {
    return FALLBACK;
  }

  const status = error.response?.status;
  const messages = extractApiErrorMessages(error);
  const firstMessage = messages[0];

  if (status === 401 || status === 403) {
    return `${FALLBACK}. Sign in to PartnerNet and try again.`;
  }

  if (firstMessage && /project .+not found/i.test(firstMessage)) {
    return firstMessage;
  }

  if (firstMessage && firstMessage !== 'Something went wrong') {
    return `${FALLBACK}: ${firstMessage}`;
  }

  return FALLBACK;
}
